import { createFileRoute, Link, Outlet, redirect, useMatches } from '@tanstack/react-router';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/google-ads')({
  beforeLoad: ({ params, location }) => {
    const basePath = `/dashboard/tenant/${params.tenantCode}/google-ads`;
    if (location.pathname === basePath) {
      throw redirect({
        to: '/dashboard/tenant/$tenantCode/google-ads/placements',
        params,
      });
    }
  },
  component: GoogleAdsLayoutRoute,
});

function GoogleAdsLayoutRoute() {
  const { tenantCode } = Route.useParams();
  const matches = useMatches();
  const currentPath = matches[matches.length - 1]?.pathname ?? '';
  const activeTab = currentPath.includes('/google-ads/gam-config') ? 'gam-config' : 'placements';

  return (
    <div className="space-y-4">
      <div className="border-b">
        <nav className="flex gap-6">
          <Link
            to="/dashboard/tenant/$tenantCode/google-ads/placements"
            params={{ tenantCode }}
            className={cn(
              'pb-3 text-sm font-medium text-muted-foreground border-b-2 border-transparent',
              activeTab === 'placements' && 'text-foreground border-primary'
            )}
          >
            Placements
          </Link>

          <Link
            to="/dashboard/tenant/$tenantCode/google-ads/gam-config"
            params={{ tenantCode }}
            className={cn(
              'pb-3 text-sm font-medium text-muted-foreground border-b-2 border-transparent',
              activeTab === 'gam-config' && 'text-foreground border-primary'
            )}
          >
            GAM Config
          </Link>
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
